import React, { useContext } from 'react';
import { Box, Button } from '@mui/material';
import { useModal } from '../../../../hooks/Modal';
import { CollectTypeContext } from '../..';
import { ModalTitle, ModalText } from './styled';

export const ModalFinancialRestriction = () => {
  const { closeModal, Modal } = useModal();

  const { protocolCollectCanceled } = useContext(CollectTypeContext);

  const handleCloseModal = () => {
    window.location.href = `${process.env.REACT_APP_URL_CLIENT_VIEW}${process.env.REACT_APP_URL_BOTAO_VOLTAR}`;
  };

  return (
    <Modal preventClose>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
          maxHeight: '86vh',
          overflow: 'auto'
        }}
      >
        <ModalTitle>ATENÇÃO</ModalTitle>

        <ModalText>
          Pedido de Coleta Cancelado - Protocolo{' '}
          <b>{protocolCollectCanceled}</b>
        </ModalText>
        <ModalText>
          Momentaneamente não estamos operando com este CNPJ/CPF.
          <br />
          Para mais informações entrar em contato com o Departamento de
          Cobrança.
        </ModalText>
        <ModalText>
          São Paulo e Região: 2223-3500 e demais regiões: 0800 775 3333
        </ModalText>

        <Button
          type="button"
          variant="contained"
          data-testid="finishFinancialRestrictionModalButton"
          onClick={handleCloseModal}
        >
          OK
        </Button>
      </Box>
    </Modal>
  );
};
